import { render, staticRenderFns } from "./PersonalReport.vue?vue&type=template&id=0766e4ae&scoped=true"
import script from "./PersonalReport.vue?vue&type=script&lang=js"
export * from "./PersonalReport.vue?vue&type=script&lang=js"
import style0 from "./PersonalReport.vue?vue&type=style&index=0&id=0766e4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0766e4ae",
  null
  
)

export default component.exports